/* eslint-disable react/destructuring-assignment */

/* eslint-disable react/prop-types */
import React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import { faEye, faLock, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form, Input, Select, Typography, Upload, message } from 'antd';
import moment from 'moment';
import Router from 'next/router';
import { changeStatusAction, createReport, uploadFile } from '@gtintel/platform-api';
import { CLOSED_ID, COMPLETE_ID, COOKIE_NAMES, DEFAULT_DATE_TIME_NOW, PROJECT_REPORT_STATE, REPORT_SELECTION_PERMISSION, REPORT_TYPE } from '@gtintel/platform-constants';
import { sendNotifications } from '@gtintel/platform-firebase';
import { getSessionStorageItem } from '@gtintel/platform-utils';
import { onChange } from './../../ReportsTab/utils';
import QANotice from './QANotice';
import * as S from './styles';
const {
  Title,
  Text
} = Typography;
const {
  Option
} = Select;
const {
  TextArea
} = Input;
function ReportContent({
  title,
  content
}) {
  return <div className="report-block">
      <h6>{title}</h6>
      <div className="content">{content}</div>
    </div>;
}
function ReportFile({
  title,
  files
}) {
  return <div className="report-file">
      <h6>{title}</h6>
      <div className="content">
        {files.map(file => <p key={file.uid}>
            {/* @ts-ignore */}
            <a href={file.thumbUrl} alt={title}>
              {file.name.substring(file.name.lastIndexOf('/') + 1).split('?')[0]}
            </a>
          </p>)}
      </div>
    </div>;
}
class NewPartnerReport extends React.Component {
  constructor(props) {
    super(props);
    this.removeChange = () => {
      this.setState({
        previewReport: false,
        name: '',
        showInputName: false,
        isNameValid: true,
        fileList: [],
        execSummary: {
          publish: REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC,
          content: ''
        },
        attachmentPermissions: REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC,
        attachments: [],
        isPublic: true
      });
    };
    this.showInputName = () => {
      this.setState({
        showInputName: true
      });
    };
    this.previewReport = () => {
      if (this.state.name.length === 0) {
        this.setState({
          isNameValid: false
        });
      } else {
        this.setState({
          previewReport: true
        });
      }
    };
    this.stopPreviewReport = () => {
      this.setState({
        previewReport: false
      });
    };
    this.onFinish = () => {
      this.setState({
        isSubmitting: true
      }, () => {
        const dateNow = moment().format(DEFAULT_DATE_TIME_NOW);
        const {
          execSummary,
          attachments,
          name
        } = this.state;
        if (name.length === 0) {
          this.setState({
            isNameValid: false,
            isSubmitting: false
          });
          return;
        }
        const reportDetails = [];
        if (execSummary.content) {
          reportDetails.push({
            type: REPORT_TYPE.REPORTSECTIONTYPE_SUMMARY,
            value: execSummary.content,
            permission: execSummary.publish,
            created_date: dateNow,
            order: 1 // this is required by the BE which we're avoiding changing:
            // There are existing reports that use the fields we're removing,
            // so we want the backend to continue to support these until we remove those reports,
            // at which point we can refactor and simplify the backend.
          });
        }
        if (attachments.length !== 0) {
          attachments.forEach((value, i) => {
            reportDetails.push({
              type: REPORT_TYPE.REPORTSECTIONTYPE_ATTACHMENT,
              // @ts-ignore
              value: value.response.results[0].url,
              permission: this.state.attachmentPermissions,
              created_date: dateNow,
              order: i + 1
            });
          });
        }
        const projectReportData = {
          name,
          state: this.state.isPublic ? PROJECT_REPORT_STATE.PUBLIC : PROJECT_REPORT_STATE.DRAFT,
          client_accept: false,
          created_date: dateNow,
          project_id: this.props.projectId,
          projectreportsdetails: reportDetails,
          published_date: null
        };
        if (this.state.isPublic) {
          projectReportData.published_date = dateNow;
        }
        const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
        createReport(projectReportData).then(async res => {
          if (this.state.isPublic) {
            this.changeStatus(COMPLETE_ID);
            sendNotifications({
              user,
              project: this.props.project,
              content: 'has published a report in',
              sendToClient: true,
              sendToAdmin: true,
              sendToPartner: false
            }).catch(() => {});
          }
          if (res.id !== undefined) {
            await message.success(`Created successfully`);
            setTimeout(() => {
              Router.reload();
            }, 1000);
          } else {
            await message.error(`Create failed!`);
          }
        }).catch(async e => {
          await message.error('An unknown error occurred.');
          console.error(e);
        });
      });
    };
    this.changeStatus = value => {
      const param = {
        status: value
      };
      if (this.props.source !== 'batch') {
        changeStatusAction(this.props.projectId, param).catch(() => console.log('Error while changing status'));
      }
    };
    this.changeAttachmentPermission = value => {
      this.setState({
        attachmentPermissions: value
      });
    };
    this.changeName = value => {
      this.setState({
        name: value.target.value,
        isNameValid: true
      });
    };
    this.changeExecSummary = value => {
      const {
        execSummary
      } = this.state;
      execSummary.content = value.target.value;
      this.setState({
        execSummary
      });
    };
    this.changePublic = () => {
      this.setState({
        isPublic: true
      });
    };
    this.nonePublic = () => {
      this.setState({
        isPublic: false
      });
    };
    this.changePublicExecSummary = value => {
      const {
        execSummary
      } = this.state;
      execSummary.publish = value;
      this.setState({
        execSummary
      });
    };
    this.state = {
      previewReport: false,
      name: '',
      showInputName: false,
      isNameValid: true,
      fileList: [],
      execSummary: {
        publish: REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PRIVATE,
        content: ''
      },
      attachmentPermissions: REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PRIVATE,
      attachments: [],
      isPublic: true,
      isSubmitting: false
    };
  }
  render() {
    const {
      attachments,
      isSubmitting
    } = this.state;
    const iconRemove = {
      removeIcon: <FontAwesomeIcon style={{
        cursor: 'pointer'
      }} className="icon-remove" icon={faTrashAlt} />
    };
    let showList;
    if (this.state.previewReport) {
      showList = <div className="report-view">
          <div className="text-center title">
            <Title data-testid="report-name">
              {this.state.name !== '' ? this.state.name : ''}
            </Title>
            <Text>Published</Text>
          </div>

          {this.state.execSummary && this.state.execSummary.content !== '' ? <ReportContent title="Executive Summary" content={<p>{this.state.execSummary.content}</p>} /> : ''}
          {attachments.length !== 0 ? <ReportFile title="Attachments" files={attachments} /> : ''}
        </div>;
    } else {
      showList = <>
          {this.state.showInputName ? <Input type="dashed" data-testid="name-report-input" placeholder="Name report" autoFocus onChange={this.changeName} value={this.state.name} /> : <Button data-public type="dashed" data-testid="name-report-button" block className="btn-add-block report-name" onClick={this.showInputName}>
              Report name
            </Button>}
          {this.state.isNameValid === false ? <div style={{
          color: 'red'
        }}>
              Please enter a name for your report
            </div> : ''}

          <div>
            <div className="d-flex">
              <p>Executive Summary</p>
              <Select className="m-right" onChange={value => this.changePublicExecSummary(value)} defaultValue={this.state.execSummary && this.state.execSummary.publish ? this.state.execSummary.publish.toString() : REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC} showArrow suffixIcon={<CaretDownOutlined />}>
                <Option value={REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC}>
                  <FontAwesomeIcon icon={faEye} /> Everyone in Project
                </Option>
                <Option value={REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PRIVATE}>
                  <FontAwesomeIcon icon={faLock} /> Only Me
                </Option>
              </Select>
            </div>
            <TextArea data-testid={`text-area-es`} placeholder="Start typing section here" onChange={value => this.changeExecSummary(value)} rows={8} value={this.state.execSummary && this.state.execSummary.content !== '' ? this.state.execSummary.content : ''} />
          </div>

          <div>
            <div className="d-flex">
              <p>Attachments</p>
              <Select className="m-right" onChange={this.changeAttachmentPermission} defaultValue={this.state.attachmentPermissions.toString()} showArrow suffixIcon={<CaretDownOutlined />}>
                <Option value={REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PUBLIC}>
                  <FontAwesomeIcon icon={faEye} /> Everyone in Project
                </Option>
                <Option value={REPORT_SELECTION_PERMISSION.REPORT_SECTION_PERMISSION_PRIVATE}>
                  <FontAwesomeIcon icon={faLock} /> Only Me
                </Option>
              </Select>
            </div>
            <div className="clearfix Attachments">
              <Upload name="files" customRequest={async ({
              file,
              onSuccess,
              onError
            }) => {
              const formData = new FormData();
              formData.append('files', file);
              formData.append('project_id', String(this.props.projectId));
              try {
                const response = await uploadFile(formData);
                onSuccess?.(response);
              } catch (error) {
                onError?.(error);
              }
            }} fileList={attachments} onChange={onChange.bind(this)} multiple showUploadList={iconRemove}>
                <Button data-public type="dashed" block className="btn-add-block report-name ">
                  <FontAwesomeIcon icon={faPlus} />
                  &ensp; Add Attachments
                </Button>
              </Upload>
            </div>
          </div>
        </>;
    }
    return <S.ReportContainer>
        {this.props.project.can_publish ? null : <QANotice />}
        <Form name="basic" onFinish={this.onFinish}>
          <div className="new-report" data-testid="new-report">
            <Form.Item className="group-button">
              <Button data-public data-testid="discard-changes-button" type="primary" className="btn-report" loading={isSubmitting} onClick={this.removeChange} disabled={this.props.project.status === CLOSED_ID}>
                DISCARD CHANGES
              </Button>
              <Button data-public data-testid="save-draft-button" type="primary" htmlType="submit" className="btn-report" loading={isSubmitting} onClick={this.nonePublic} disabled={this.props.project.status === CLOSED_ID}>
                SAVE DRAFT
              </Button>
              {this.state.previewReport ? <Button data-public data-testid="return-create-button" type="primary" className="btn-report" onClick={this.stopPreviewReport} disabled={this.props.project.status === CLOSED_ID}>
                  EDIT REPORT
                </Button> : <Button data-public type="primary" data-testid="preview-report-button" className="btn-report" onClick={this.previewReport} disabled={this.props.project.status === CLOSED_ID}>
                  PREVIEW REPORT
                </Button>}

              <Button disabled={!this.props.project.can_publish} data-public type="primary" data-testid="publish-button" htmlType="submit" className="btn-complete" loading={isSubmitting} onClick={this.changePublic}>
                PUBLISH
              </Button>
            </Form.Item>
            {showList}
          </div>
        </Form>
      </S.ReportContainer>;
  }
}
export default NewPartnerReport;